import { v3 } from '@adobe/edex/frontend/api/v3';
import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';

const baseURL = '/metadata';

export function fetchMetadataByType(type: MetadataType) {
  return v3.get(baseURL, { params: { types: type } });
}
